import { useTranslation } from 'react-i18next';
import { PlusIcon } from '@vlabs/icons';
import { SUPPORTED_TYPES_FOR_CAPTION, MAX_SIZE_IN_MB } from './constants';


export const DefaultCaption = () => {
  const { t } = useTranslation();

  return (
    <div className="FileDropzone__Caption">
      <PlusIcon />

      <span className="FileDropzone__CaptionTitle">
        {t('shared:drag_or_click_file')}
      </span>

      <span className="FileDropzone__CaptionDescription">
        {t('checks:check video audio.dropzone.caption.supported types',
          { supportedTypes: SUPPORTED_TYPES_FOR_CAPTION.join(', ') }
        )}
      </span>
      <span className="FileDropzone__CaptionDescription">
        {t('checks:check video audio.dropzone.caption.max size',
          { maxSize: MAX_SIZE_IN_MB.toString() }
        )}
      </span>
    </div>
  );
}
